import React, { FC } from "react";
import { Collapse, Checkbox, Input, Spin } from "antd";

// import "./filterForDayCalender.scss";
import "../../../../../../style/main.scss";
import "./filterForMonthCalender.scss";

import { RightOutlined } from "@ant-design/icons";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const { Panel } = Collapse;

const FilterForMonthCalender: FC<any> = ({ masterFilterDataMonth, copyMonthFilter, onOptionSelection, onOptionSearch, copyMasterFilterDataMonthSearch, isloadingFilter, selectedActiveFilters, onCollapseChange }) => {

  //<DownOutlined rotate={isActive ? 90 : -90} style={{ fontSize: "14px", color: "#42526e" }} />
  return (
    <>
      {isloadingFilter ? <div className="loaderForFilter"><Spin size="large" indicator={<HealthemSpinner/>}/></div> : null}
      <div className="drawerFiltersWrapper calender_month__filter">
      <Collapse activeKey={selectedActiveFilters} expandIconPosition={"right"} onChange={(key)=>onCollapseChange(key)} expandIcon={({ isActive }) => <RightOutlined style={{ fontSize: "14px", color: "#42526e" }}/> }>
          {masterFilterDataMonth.map((filter: any, index:any) => {
            return (
              <Panel header={filter.label} key={filter.columnName} className={`filtersPanel`}>
                {copyMasterFilterDataMonthSearch[index]?.filterValues?.length > 5 ? (
                  <Input
                    onChange={(e: any) => {onOptionSearch(e, index, filter.columnName)}}
                    allowClear={true}
                    className="inputForSearchFilter"
                    placeholder={`Search ${filter.label
                      .split(" ")
                      .map((str: any) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase())
                      .join(" ")}`}
                  />
                ) : null}

                <Checkbox.Group
                  disabled={isloadingFilter}
                  name={filter.label}
                  options={filter.filterValues}
                  value={copyMonthFilter[filter.columnName]}
                  onChange={(selectedArray) => {onOptionSelection(selectedArray, index, filter.columnName, copyMasterFilterDataMonthSearch[index].filterValues)}}
                  className={`${filter?.filterValues?.length > 5 ? "panelWithMoreOption custom-scroll-bar" : ""}`}
                />
              </Panel>
            );
          })}
      </Collapse>
    </div>
    </>
  )
};

export default FilterForMonthCalender;
